import { useTRPCClientAPI, useTRPCMutation } from '../../../../trpc/trpc';
import { useInvalidateOutreach } from './useInvalidateOutreach';

/** The writes of a People row (design outreach-v2 g2): "Fewer playlists like this" and "Stop the follow-up". */
export function usePeopleActions(accountId: number, campaignUuid: string) {
  const trpcClient = useTRPCClientAPI();
  const invalidate = useInvalidateOutreach();
  const done = () => invalidate(['campaigns']);
  const dislike = useTRPCMutation({
    mutationFn: (messageUuid: string) =>
      trpcClient.outreach.campaigns.dislike.mutate({ accountId, campaignUuid, messageUuid }) as Promise<{
        dislikes: number;
      }>,
  });
  const stopFollowUp = useTRPCMutation({
    mutationFn: (messageUuid: string) =>
      trpcClient.outreach.campaigns.stopFollowUp.mutate({ accountId, campaignUuid, messageUuid }) as Promise<{
        cancelled: number;
      }>,
    onSuccess: done,
  });
  return {
    dislike: dislike.mutateAsync,
    stopFollowUp: stopFollowUp.mutateAsync,
    isWriting: dislike.isPending || stopFollowUp.isPending,
  };
}
